<template>
  <div class="grid-item bg-lightning" v-flash="'lightning'">
    <h1><font-awesome-icon icon="bolt" /></h1>
    <u>Gewitter</u>
    <br>
    <svg class="radar" :class="{ flash }" viewBox="0 0 200 200" width="170" height="170" xmlns="http://www.w3.org/2000/svg">
      <circle cx="100" cy="100" r="95" fill="#1d1733" fill-opacity="0.55" />
      <g fill="none" stroke="#fff" stroke-opacity="0.45" stroke-width="1">
        <circle v-for="r in RINGS" :key="r.km" cx="100" cy="100" :r="r.r" />
        <line x1="100" y1="5" x2="100" y2="195" stroke-opacity="0.2" />
        <line x1="5" y1="100" x2="195" y2="100" stroke-opacity="0.2" />
      </g>
      <g font-size="9" fill="#fff" fill-opacity="0.8" text-anchor="middle">
        <text v-for="r in RINGS" :key="r.km" x="100" :y="100 - r.r - 2">{{ r.km }} km</text>
      </g>
      <circle cx="100" cy="100" r="3" fill="#fff" />
      <g v-if="strike" class="strike">
        <circle :cx="strike.x" :cy="strike.y" r="9" fill="#ffe14d" fill-opacity="0.35" />
        <circle :cx="strike.x" :cy="strike.y" r="4" :fill="strike.inside ? '#ffe14d' : 'none'"
                stroke="#ffe14d" stroke-width="2" />
      </g>
    </svg>
    Aktuell <b>{{current_rate}} Blitze/h</b>
    <br>
    <br>Letzter Blitz:
    <br>
    vor <b>{{delay_lastevent_number}} {{delay_lastevent_unit}}</b>
    in <b>{{dist}}km</b>
  </div>
</template>

<script>
const MAX_KM = 20
const MAX_R = 90
const RINGS = [5, 10, 20].map(km => ({ km, r: km / MAX_KM * MAX_R }))

const MINUTES_PER_UNIT = { Minuten: 1, Stunden: 60, Tage: 1440 }

export default {
  name: 'LightningValues',
  props: {
    dist: Number,
    delay_lastevent_number: Number,
    delay_lastevent_unit: String,
    current_rate: Number
  },
  data() {
    return { RINGS, flash: false }
  },
  computed: {
    // the sensor reports no bearing, so the strike is drawn in a fixed direction
    strike() {
      if (!Number.isFinite(this.dist)) return null
      const r = Math.min(this.dist, MAX_KM) / MAX_KM * MAX_R
      const a = 45 * Math.PI / 180
      return { x: 100 + r * Math.sin(a), y: 100 - r * Math.cos(a), inside: this.dist <= MAX_KM }
    },
    delayMinutes() {
      const unit = MINUTES_PER_UNIT[this.delay_lastevent_unit]
      return unit && Number.isFinite(this.delay_lastevent_number) ? this.delay_lastevent_number * unit : null
    }
  },
  watch: {
    // the delay only ever grows, so a decrease means a new strike
    delayMinutes(next, prev) {
      if (next === null || prev === null || next >= prev) return
      this.flash = false
      // restart the CSS animation
      this.$nextTick(() => { this.flash = true })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-lightning  { background-color: #7463a4; }

.radar {
  display: block;
  margin: 10px auto;
  border-radius: 50%;
}

.radar.flash {
  animation: flash 2.4s ease-out;
}

@keyframes flash {
  0%, 15%, 30% { box-shadow: 0 0 25px 8px #ffe14d; }
  22% { box-shadow: none; }
  100% { box-shadow: none; }
}
</style>
